import { useEffect, useState } from 'react';
import { Select } from '@lmig/lmds-react-select';
import { Button } from '@lmig/lmds-react-button';
import { Link } from '@lmig/lmds-react-link';
import FilterTableDataUtility from 'Utilities/FilterTableDataUtility';

const RecentActivitiesFilterWindow = (props: any) => {
  const [items, setItems] = useState([]);
  const [filterList, setFilterList] = useState<any[]>([]);
  
  useEffect(() => {
    setItems(props.items)
    configureFilterList(props.items)

  }, []);
  

  const configureFilterList = (dataset: any) => {
    //gets which columns are supposed to have a filter
    let filterList = [];
    for (let i = 0; i < props.columns.length; i++) {
      if (props.columns[i].hasFilter) {
        let select = buildFilterDropDowns(
          props.columns[i].columnKey,
          dataset,
          props.columns[i].columnDisplayText,
        );
        filterList.push({ key: props.columns[i].columnKey, value: select });
      }
    }
    setFilterList(filterList);
  };

 const buildFilterDropDowns = (property: any, dataset:any, displayText:any) => {
    //build out structure of select using design system select
    let selectOptions = FilterTableDataUtility.buildFilterSelectOptions(property, dataset);
    let selectId = props.activityDataType + '-' + property + '-filter';

    let select = (
      <Select
        key={selectId}
        id={selectId}
        className={'filterDropDown'}
        labelA11y={displayText}
        labelVisual={displayText}
        placeholderOption={displayText}
      >
        {selectOptions}
      </Select>
    );
    return select;
  };

  const getAllDropDownLists = () => {
    if ( document.getElementById(props.activityDataType + '-dropdown-contents') != null)
    {
      let el = document.getElementById(props.activityDataType + '-dropdown-contents')
      if (el)
        return el.getElementsByClassName('lm-Field-select');
    }
    else return [];
  };

  const displayDataFromSelectedFilters = () => {
    let selectList = getAllDropDownLists();
    let updatedFilteredOptions = FilterTableDataUtility.getUpdatedFilterOptionsFromList(selectList as Element[]);
    toggleVisibility(false);
    let filteredResults = FilterTableDataUtility.getFilteredResults(items, updatedFilteredOptions);
    updateView(filteredResults, updatedFilteredOptions);
  };

  const updateView = (filteredResults: any, updatedFilteredOptions: any) => {
    props.updateView(filteredResults, updatedFilteredOptions);
  };

  const toggleVisibility = (shouldResetLists: boolean) => {
    let prevState = props.hideDropDown;
    if (shouldResetLists && prevState === false) {
      resetSelectLists();
    }
    props.toggleVisibility();
  };

  const resetSelectLists = () => {
    let selectLists = getAllDropDownLists();
    if (selectLists) {
      for (let i = 0; i < selectLists.length; i++) {
        let dropdown = selectLists[i];
        if (props.filteredOptions.find((item:any) => item.id === dropdown.id)) {
          let item = props.filteredOptions.find((item:any) => item.id === dropdown.id);
          if (item.value !== (dropdown as any).value) {
            (dropdown as any).value = item.value;
          }
        } else {
          //if it doesn't exist in the filter options its because previously "all" was selected, so reset if not all already.
          if (dropdown && dropdown.id !=null && document.getElementById(dropdown.id) !=null) {
            (document.getElementById(dropdown.id) as HTMLInputElement).value = 'All';
          }
        }
      }
    }
    
  };

  const resetAllFilters = () => {
    configureFilterList(items);
    for (let i = 0; i < filterList.length; i++) {
      let select = filterList[i].value;
      if (select.props.id) {
        (document.getElementById(select.props.id + '-select')  as HTMLSelectElement).selectedIndex = 0;
        document.getElementById(select.props.id)?.classList.remove('is-populated');
        let el = document.getElementById(select.props.id + '-select') as HTMLInputElement;
        if (el)
          el.value = 'All';

      }
    }
    updateView(items, []);
  };

    return (
      <div className="filterContainer">
        <div
          id={props.activityDataType + '-dropdown-contents'}
          className="filterDropdownContents"
          hidden={props.hideDropDown}
        >
          {filterList && filterList.map(filter => filter.value)}
          <div className="filterLinksAndButtonsRow">
            <div className="filterButtonsContainer">
              <Button size="small" variant="primary" onClick={() => displayDataFromSelectedFilters()}>
                OK
              </Button>
              <Button size="small" onClick={() => toggleVisibility(true)}>
                Close
              </Button>
            </div>
            <div className="filterLinkContainer">
              <Link style={{ marginLeft: '10px' }} onClick={() => resetAllFilters()}>
                Reset All
              </Link>
            </div>
          </div>
        </div>
      </div>
    );

}

export default RecentActivitiesFilterWindow;
